/** The documents' own pages, each titled by its sidebar entry's name. */
export const DOC_PAGE_TITLES: Readonly<Record<string, string>> = {
  '/documents/unfiled': 'Unfiled',
  '/documents/folders': 'All folders',
  '/documents/shared-with-me': 'Shared with me',
  '/documents/deleted': 'Recently deleted',
  '/documents/activity': 'Activity',
}
